import { differenceInCalendarDays, format, isToday, isValid } from 'date-fns';
import { pl } from 'date-fns/locale';

/** Names the nearest few days for us — `dzisiaj`, `wczoraj`, `przedwczoraj` —
 *  so the separator carries no date strings of its own. */
const relativeDays = new Intl.RelativeTimeFormat('pl', { numeric: 'auto' });
const NAMED_DAYS = 2;

export function formatDateTime(value: number | null) {
  if (value === null) {
    return '';
  }

  const date = new Date(value);

  if (!isValid(date)) {
    return '';
  }

  return format(date, isToday(date) ? 'HH:mm' : 'dd.MM, HH:mm', {
    locale: pl,
  });
}

export function formatDay(value: number | null) {
  if (value === null) {
    return '';
  }

  const date = new Date(value);

  if (!isValid(date)) {
    return '';
  }

  const days = differenceInCalendarDays(date, new Date());

  if (days <= 0 && days >= -NAMED_DAYS) {
    const named = relativeDays.format(days, 'day');

    return named.charAt(0).toUpperCase() + named.slice(1);
  }

  return format(date, 'd MMMM yyyy', { locale: pl });
}

export function localDayKey(value: number | null) {
  if (value === null) {
    return '';
  }

  const date = new Date(value);

  if (!isValid(date)) {
    return '';
  }

  return format(date, 'yyyy-MM-dd');
}
